import { render, staticRenderFns } from "./empWagesDetailList.vue?vue&type=template&id=71d1e57a&scoped=true&"
import script from "./empWagesDetailList.vue?vue&type=script&lang=js&"
export * from "./empWagesDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1e57a",
  null
  
)

export default component.exports